<template>
  <div class="reportTable">
    <!-- F10 -->
    <div class="title">
      <ul>
        <li>
          <span>打印日期：</span>
          <span>{{ $parent.nowday }}</span>
        </li>
        <li>
          <span>打印时间：</span>
          <span>{{ $parent.nowtime }}</span>
        </li>
        <li>
          <span>酒店日期：</span>
          <span>{{ $parent.hotelInfo.dhoteltime }}</span>
        </li>
      </ul>
      <ul style="display: flex; flex-direction: column; align-items: center">
        <li>
          <span></span>
          <span>{{ $parent.hotelInfo.cname }}</span>
        </li>
        <li>
          <span></span>
          <span>{{ $parent.bbmc }}</span>
        </li>
        <li>
          <span>查询日期：</span>
          <span>
            {{ this.$moment(this.$parent.startDate).format("YYYY-MM-DD") }}
          </span>
          <span v-if="$parent.endTimeShow">
            至{{ this.$moment(this.$parent.endDate).format("YYYY-MM-DD") }}
          </span>
        </li>
      </ul>
      <ul style="display: flex; flex-direction: column; align-items: flex-end">
        <li>
          <span>操作员:</span>
          <span>{{ $parent.userInfo.cname }}</span>
        </li>
        <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
        </li>-->
        <li v-if="$parent.datacount > 0">
          <span>总条数:</span>
          <span>{{ $parent.datacount }}条</span>
        </li>
      </ul>
    </div>
    <div class="report">
      <div class="title-label">U05夜审稽核报表</div>
      <div class="form-content">
        <div class="contentTable">营业收入</div>
        <ul class="formTitle">
          <li style="width: 90px">序号</li>
          <li>项目</li>
          <li>主营</li>
          <li>食品</li>
          <li>香烟</li>
          <li>酒水</li>
          <li>杂项</li>
          <li>餐折扣</li>
          <li>桑拿</li>
          <li></li>
          <li>合计</li>
          <li style="width: 90px">序号</li>
          <li>项目</li>
          <li>主营</li>
          <li>食品</li>
          <li>香烟</li>
          <li>酒水</li>
          <li>杂项</li>
          <li>餐折扣</li>
          <li>桑拿</li>
          <li></li>
          <li>合计</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>

      <!-- 收款记账 -->
      <div class="form-content">
        <div class="contentTable">收款记账</div>
        <ul class="formTitle">
          <li style="width: 90px">序号</li>
          <li>项目</li>
          <li>主营</li>
          <li>食品</li>
          <li>香烟</li>
          <li>酒水</li>
          <li>杂项</li>
          <li>餐折扣</li>
          <li>桑拿</li>
          <li></li>
          <li>合计</li>
          <li style="width: 90px">序号</li>
          <li>项目</li>
          <li>主营</li>
          <li>食品</li>
          <li>香烟</li>
          <li>酒水</li>
          <li>杂项</li>
          <li>餐折扣</li>
          <li>桑拿</li>
          <li></li>
          <li>合计</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 本日预到的宾客表
      preArrivalList: [],
      // 已经登记宾客表
      registeredList: [],
      // 今日在店宾客报表
      inStoreTitleList: [],
      queryDate: "",
      date: "",
    };
  },
  created() {
    this.$parent.bbmc = "U05.夜审稽核报表";
    this.$parent.closeshow();
    this.$parent.isShow2 = false;
    this.queryDate = new Date();
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.date = this.$moment(this.queryDate).format("YYYY-MM-DD HH:mm:ss");
    this.getPreArrivalList();
  },
  methods: {
    dateChange(data) {
      this.date = this.$moment(data).format("YYYY-MM-DD HH:mm:ss");
    },
    getPreArrivalList() {},
  },
};
</script>

